(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[769],{

/***/ 2199:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/page/[idx]",
      function () {
        return __webpack_require__(9825);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_CategoryTag; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 24 modules
var withStyles = __webpack_require__(9438);
;// CONCATENATED MODULE: ./components/CategoryTag/style.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var styles = function(theme) {
    var _obj;
    return {
        CategoryTag: (_obj = {
            cursor: "pointer",
            borderRadius: 6,
            backgroundColor: "#f5faff",
            padding: theme.spacing(2),
            fontFamily: "Raleway,Assistant",
            fontSize: 16,
            fontWeight: 700,
            color: "#4c4c78",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }, _defineProperty(_obj, theme.breakpoints.down("sm"), {
            margin: theme.spacing(0),
            fontSize: 15
        }), _defineProperty(_obj, theme.breakpoints.down("xs"), {
            width: "100%",
            fontSize: 16
        }), _defineProperty(_obj, "&:hover", {
            backgroundColor: "#4a92cf",
            color: "#fff"
        }), _defineProperty(_obj, "& .activeTag", {
            backgroundColor: "#4a92cf",
            color: "#fff"
        }), _defineProperty(_obj, "& img", {
            marginLeft: theme.direction === "ltr" ? 0 : 8,
            marginRight: theme.direction === "ltr" ? 8 : 0,
            width: 14
        }), _obj)
    };
};
/* harmony default export */ var style = (styles);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
;// CONCATENATED MODULE: ./components/CategoryTag/index.js






var CategoryTag = function(param) {
    var classes = param.classes, CategoryTagIconSrc = param.CategoryTagIconSrc, CategoryTagIconAlt = param.CategoryTagIconAlt, CategoryTagTitle = param.CategoryTagTitle, showIcon = param.showIcon, selected = param.selected;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.CategoryTag,
        children: [
            showIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: CategoryTagIconSrc,
                alt: CategoryTagIconAlt
            }),
            CategoryTagTitle
        ]
    });
};
CategoryTag.defaultProps = {
    showIcon: false
};
CategoryTag.propTypes = {
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    CategoryTagIconSrc: (prop_types_default()).string,
    CategoryTagIconAlt: (prop_types_default()).string,
    CategoryTagTitle: (prop_types_default()).string,
    showIcon: (prop_types_default()).bool
};
/* harmony default export */ var components_CategoryTag = ((0,withStyles/* default */.Z)(style)(CategoryTag));


/***/ }),

/***/ 4394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prismic_reactjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5833);
/* harmony import */ var prismic_reactjs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prismic_reactjs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1752);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);







var Head = function(param) {
    var data = param.data, canonical = param.canonical;
    var siteUrl = (0,next_config__WEBPACK_IMPORTED_MODULE_5__["default"])().publicRuntimeConfig.siteUrl;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var canonicalUrl = canonical === "/homepage" ? "".concat(siteUrl, "/").concat(router.locale) : "".concat(siteUrl, "/").concat(router.locale).concat(canonical);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: "/apple-touch-icon.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "32x32",
                href: "/favicon-32x32.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "16x16",
                href: "/favicon-16x16.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "manifest",
                href: "/site.webmanifest"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "mask-icon",
                href: "/safari-pinned-tab.svg",
                color: "#d6a560"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "msapplication-TileColor",
                content: "#ffffff"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "theme-color",
                content: "#ffffff"
            }),
            data.meta_title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: prismic_reactjs__WEBPACK_IMPORTED_MODULE_4__.RichText.asText(data.meta_title)
            }),
            !data.meta_title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: "VFI"
            }),
            data.meta_description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: prismic_reactjs__WEBPACK_IMPORTED_MODULE_4__.RichText.asText(data.meta_description)
            }),
            data.meta_title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: prismic_reactjs__WEBPACK_IMPORTED_MODULE_4__.RichText.asText(data.meta_title)
            }),
            data.meta_description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: prismic_reactjs__WEBPACK_IMPORTED_MODULE_4__.RichText.asText(data.meta_description)
            }),
            data.og_image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: data.og_image.url
            }),
            data.robots_index && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: data.robots_index ? "all" : "noindex"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            })
        ]
    });
};
Head.propTypes = {
    data: prop_types__WEBPACK_IMPORTED_MODULE_2___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_2___default().any))
};
/* harmony default export */ __webpack_exports__["Z"] = (Head);


/***/ }),

/***/ 5568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_PersonItem; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 24 modules
var withStyles = __webpack_require__(9438);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(2318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
;// CONCATENATED MODULE: ./components/PersonItem/style.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var styles = function(theme) {
    var _obj, _obj1;
    return {
        speaker: {
            boxShadow: "0 22px 57px 0 rgba(37, 44, 80, 0.5)",
            backgroundColor: "#ffffff",
            cursor: "pointer",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            "&>a": {
                display: "flex",
                flexDirection: "column",
                height: "100%"
            },
            "& .itemImage": {
                verticalAlign: "bottom"
            },
            "& .speakerInfo": (_obj1 = {
                display: "flex",
                flexDirection: "column",
                padding: theme.spacing(4)
            }, _defineProperty(_obj1, theme.breakpoints.down("sm"), {
                padding: theme.spacing(3)
            }), _defineProperty(_obj1, theme.breakpoints.down("xs"), {
                padding: theme.spacing(2)
            }), _defineProperty(_obj1, "flex", 1), _defineProperty(_obj1, "& .tag", (_obj = {
                display: "inline-block",
                borderRadius: 2,
                width: "fit-content",
                backgroundColor: "#4a92cf",
                padding: theme.spacing(0.5),
                paddingLeft: theme.spacing(1.5),
                paddingRight: theme.spacing(1.5),
                marginBottom: theme.spacing(2),
                fontSize: 12,
                color: "#ffffff",
                fontWeight: 700,
                textTransform: "uppercase"
            }, _defineProperty(_obj, theme.breakpoints.down("sm"), {
                fontSize: 11
            }), _defineProperty(_obj, theme.breakpoints.down("xs"), {
                fontSize: 10
            }), _defineProperty(_obj, "& a", {
                color: "#fff"
            }), _obj)), _defineProperty(_obj1, "& .name", {
                color: "#4c4c78",
                lineHeight: 1.19,
                fontWeight: 700,
                flex: 1
            }), _defineProperty(_obj1, "& .title", _defineProperty({
                lineHeight: 1.67,
                color: "#4c4c78",
                fontWeight: 500,
                fontFamily: "Raleway,Assistant,sans-serif",
                marginTop: theme.spacing(2),
                display: "block"
            }, theme.breakpoints.down("sm"), {
                marginTop: theme.spacing(1)
            })), _defineProperty(_obj1, "& button", _defineProperty({
                width: "100%",
                marginTop: theme.spacing(2)
            }, theme.breakpoints.down("sm"), {
                marginTop: theme.spacing(1)
            })), _obj1)
        }
    };
};
/* harmony default export */ var style = (styles);

// EXTERNAL MODULE: ./components/CustomLink/index.js + 1 modules
var CustomLink = __webpack_require__(6833);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/PersonItem/index.js









var PersonItem = function(param) {
    var classes = param.classes, tag = param.tag, name = param.name, title = param.title, bannerImageSrc = param.bannerImageSrc, bannerImageAlt = param.bannerImageAlt, btnLabel = param.btnLabel, showTag = param.showTag, showBtn = param.showBtn, link = param.link;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.speaker,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomLink/* default */.Z, {
            link: link ? link : {},
            class: "custLinkItem",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        position: "relative",
                        height: 273,
                        width: "100%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        objectFit: "cover",
                        layout: "fill",
                        src: bannerImageSrc,
                        alt: bannerImageAlt,
                        className: "itemImage"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "speakerInfo",
                    children: [
                        showTag && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tag",
                            children: tag
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h5",
                            className: "name",
                            children: name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h6",
                            className: "title",
                            children: title
                        }),
                        showBtn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "outlined",
                            color: "primary",
                            children: btnLabel
                        })
                    ]
                })
            ]
        })
    });
};
PersonItem.defaultProps = {
    tag: "",
    btnLabel: "",
    showTag: false,
    showBtn: false
};
PersonItem.propTypes = {
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    tag: (prop_types_default()).any,
    name: (prop_types_default()).string,
    title: (prop_types_default()).string,
    bannerImageSrc: (prop_types_default()).string,
    bannerImageAlt: (prop_types_default()).string,
    btnLabel: (prop_types_default()).string,
    showTag: (prop_types_default()).bool,
    showBtn: (prop_types_default()).bool
};
/* harmony default export */ var components_PersonItem = ((0,withStyles/* default */.Z)(style)(PersonItem));


/***/ }),

/***/ 8785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_TitleSubtitle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 24 modules
var withStyles = __webpack_require__(9438);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(2318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(1749);
;// CONCATENATED MODULE: ./components/TitleSubtitle/style.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var styles = function(theme) {
    var _obj, _obj1, _obj2, _obj3;
    return {
        whiteTxt: {
            "& .title": {
                color: "#fff",
                textTransform: "uppercase",
                textAlign: "center"
            },
            "& .subtitle": (_obj1 = {
                color: "#fff",
                textAlign: "center",
                fontWeight: 700,
                marginTop: theme.spacing(3),
                letterSpacing: 1.1,
                fontSize: 18,
                lineHeight: 1.5
            }, _defineProperty(_obj1, theme.breakpoints.down("sm"), {
                marginTop: theme.spacing(2),
                fontSize: 17
            }), _defineProperty(_obj1, theme.breakpoints.down("xs"), {
                marginTop: theme.spacing(1),
                fontSize: 16
            }), _defineProperty(_obj1, "& p", (_obj = {
                color: "#4c4c78",
                textAlign: "center",
                letterSpacing: 1.1,
                fontWeight: 700,
                marginTop: theme.spacing(3),
                fontSize: 18,
                lineHeight: 1.5
            }, _defineProperty(_obj, theme.breakpoints.down("sm"), {
                marginTop: theme.spacing(2),
                fontSize: 17
            }), _defineProperty(_obj, theme.breakpoints.down("xs"), {
                marginTop: theme.spacing(1),
                fontSize: 16
            }), _defineProperty(_obj, "& strong", {
                fontWeight: 900
            }), _obj)), _obj1)
        },
        blueTxt: {
            "& .title": {
                color: "#4c4c78",
                textTransform: "uppercase",
                textAlign: "center"
            },
            "& .subtitle": (_obj3 = {
                color: "#4c4c78",
                textAlign: "center",
                letterSpacing: 1.1,
                fontWeight: 700,
                marginTop: theme.spacing(3),
                fontSize: 18,
                lineHeight: 1.5
            }, _defineProperty(_obj3, theme.breakpoints.down("sm"), {
                marginTop: theme.spacing(2),
                fontSize: 17
            }), _defineProperty(_obj3, theme.breakpoints.down("xs"), {
                marginTop: theme.spacing(1),
                fontSize: 16
            }), _defineProperty(_obj3, "& p", (_obj2 = {
                color: "#4c4c78",
                textAlign: "center",
                letterSpacing: 1.1,
                fontWeight: 700,
                marginTop: theme.spacing(3),
                fontSize: 18,
                lineHeight: 1.5
            }, _defineProperty(_obj2, theme.breakpoints.down("sm"), {
                marginTop: theme.spacing(2),
                fontSize: 17
            }), _defineProperty(_obj2, theme.breakpoints.down("xs"), {
                marginTop: theme.spacing(1),
                fontSize: 16
            }), _defineProperty(_obj2, "& strong", {
                fontWeight: 900
            }), _obj2)), _obj3)
        }
    };
};
/* harmony default export */ var style = (styles);

;// CONCATENATED MODULE: ./components/TitleSubtitle/index.js







var TitleSubtitle = function(param) {
    var classes = param.classes, title = param.title, subtitle = param.subtitle, showClass = param.showClass;
    subtitle = subtitle || "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
        container: true,
        className: showClass ? classes.whiteTxt : classes.blueTxt,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
            item: true,
            xs: 12,
            container: true,
            alignItems: "center",
            justify: "center",
            direction: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h1",
                    component: "h2",
                    className: "title",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "subtitle",
                    children: subtitle
                })
            ]
        })
    });
};
TitleSubtitle.defaultProps = {
    showClass: false
};
TitleSubtitle.propTypes = {
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    title: (prop_types_default()).string,
    subtitle: (prop_types_default()).any,
    showClass: (prop_types_default()).bool
};
/* harmony default export */ var components_TitleSubtitle = ((0,withStyles/* default */.Z)(style)(TitleSubtitle));


/***/ }),

/***/ 9825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _idx_; },
  "queryParams": function() { return /* binding */ queryParams; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./utils/layout-context.tsx
var layout_context = __webpack_require__(5385);
// EXTERNAL MODULE: ./components/Head/index.js
var Head = __webpack_require__(4394);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(5833);
;// CONCATENATED MODULE: ./components/AllBlogs/style.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var styles = function(theme) {
    var _obj, _obj1, _obj2, _obj3;
    return {
        featuredBlogs: (_obj2 = {
            backgroundPosition: "center",
            backgroundSize: "150% 100%",
            backgroundRepeat: "no-repeat",
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10),
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column"
        }, _defineProperty(_obj2, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9),
            backgroundSize: "cover"
        }), _defineProperty(_obj2, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), _defineProperty(_obj2, "& .CategoryTagWrapper", (_obj = {
            marginTop: theme.spacing(10),
            marginBottom: theme.spacing(10)
        }, _defineProperty(_obj, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(9),
            marginBottom: theme.spacing(9)
        }), _defineProperty(_obj, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(8),
            marginBottom: theme.spacing(8)
        }), _obj)), _defineProperty(_obj2, "& .featureBlogsContainer", (_obj1 = {
            marginTop: theme.spacing(10)
        }, _defineProperty(_obj1, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(9)
        }), _defineProperty(_obj1, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(8)
        }), _obj1)), _obj2),
        pagination: (_obj3 = {
            marginTop: theme.spacing(10),
            fontSize: 20,
            fontWeight: 600
        }, _defineProperty(_obj3, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(9),
            fontSize: 19
        }), _defineProperty(_obj3, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(8),
            fontSize: 18
        }), _defineProperty(_obj3, "& button", {
            width: 90,
            minWidth: "unset",
            marginLeft: 16,
            marginRight: 16
        }), _obj3)
    };
};
/* harmony default export */ var style = (styles);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 24 modules
var withStyles = __webpack_require__(9438);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(3832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(1749);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./components/PersonItem/index.js + 1 modules
var PersonItem = __webpack_require__(5568);
// EXTERNAL MODULE: ./components/TitleSubtitle/index.js + 1 modules
var TitleSubtitle = __webpack_require__(8785);
// EXTERNAL MODULE: ./components/CategoryTag/index.js + 1 modules
var CategoryTag = __webpack_require__(1130);
// EXTERNAL MODULE: ./components/CustomLink/index.js + 1 modules
var CustomLink = __webpack_require__(6833);
;// CONCATENATED MODULE: ./components/AllBlogs/index.js















var section = {
    maxWidth: "600px",
    margin: "4em auto",
    textAlign: "center"
};
var h2 = {
    color: "#8592e0"
};
var dateOptions = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
};
var AllBlogs = function(param) {
    var classes = param.classes, allBlogs = param.allBlogs, allBlogCategories = param.allBlogCategories, params = param.params, blogPostData = param.blogPostData;
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    var ref = (0,react.useState)(allBlogs.results), results = ref[0], setResults = ref[1];
    return layout ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.featuredBlogs,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            maxWidth: "lg",
            children: [
                blogPostData && blogPostData.data && /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSubtitle/* default */.Z, {
                    title: prismic_reactjs.RichText.asText(blogPostData.data.title),
                    subtitle: prismic_reactjs.RichText.asText(blogPostData.data.subtitle),
                    showClass: false
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    spacing: 4,
                    direction: "row",
                    justify: "center",
                    alignItems: "center",
                    className: "CategoryTagWrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            md: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                link: {
                                    type: "learn"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTag/* default */.Z, {
                                    selected: true,
                                    CategoryTagTitle: prismic_reactjs.RichText.asText(layout.blog_view_all_button_text),
                                    showIcon: false
                                })
                            })
                        }, "random"),
                        allBlogCategories.results.map(function(category, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                md: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                    link: category,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTag/* default */.Z, {
                                        CategoryTagTitle: prismic_reactjs.RichText.asText(category.data.topic_name),
                                        showIcon: false
                                    })
                                })
                            }, index);
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    container: true,
                    spacing: 4,
                    direction: "row",
                    justify: "center",
                    className: "featureBlogsContainer",
                    children: allBlogs.results.map(function(blog, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            sm: 6,
                            md: index == 0 || index == 1 ? 6 : 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonItem/* default */.Z, {
                                link: blog,
                                showTag: blog.data.blog_topics && blog.data.blog_topics.length > 0,
                                tag: blog.data.blog_topics && blog.data.blog_topics.length > 0 && blog.data.blog_topics[0].blog_topic.data && blog.data.blog_topics[0].blog_topic.data.topic_name ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                    link: blog.data.blog_topics[0].blog_topic,
                                    children: prismic_reactjs.RichText.asText(blog.data.blog_topics[0].blog_topic.data.topic_name)
                                }) : null,
                                bannerImageSrc: blog.data.featured_image.url,
                                bannerImageAlt: blog.data.featured_image.alt,
                                name: prismic_reactjs.RichText.asText(blog.data.title),
                                title: (0,prismic_reactjs.Date)(blog.data.date).toLocaleDateString((0,router.useRouter)().locale, dateOptions)
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    container: true,
                    justify: "center",
                    alignItems: "center",
                    className: classes.pagination,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        item: true,
                        children: [
                            params.idx > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                link: {
                                    type: "learn",
                                    idx: +params.idx - 1
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "contained",
                                    color: "primary",
                                    size: "small",
                                    children: prismic_reactjs.RichText.asText(layout.blog_previous_button)
                                })
                            }),
                            params.idx < allBlogs.total_pages && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                link: {
                                    type: "learn",
                                    idx: +params.idx + 1
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "contained",
                                    color: "primary",
                                    size: "small",
                                    children: prismic_reactjs.RichText.asText(layout.blog_next_button)
                                })
                            })
                        ]
                    })
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: "...Loading"
    });
};
AllBlogs.propTypes = {
    slice: (0,prop_types.shape)({
        primary: (0,prop_types.shape)({
            title: prop_types.array.isRequired
        }).isRequired
    }).isRequired
};
/* harmony default export */ var components_AllBlogs = ((0,withStyles/* default */.Z)(style)(AllBlogs));

;// CONCATENATED MODULE: ./pages/blog/page/[idx].js





var BlogPage = function(props) {
    var all_blogs = props.all_blogs, all_blog_categories = props.all_blog_categories, params = props.params, blogPostData = props.blogPostData;
    var setHeaderColor = (0,layout_context/* useLayout */.$Y)().setHeaderColor;
    var canonical = params.idx === 1 || params.idx === "1" ? "/blog" : "/blog/page/".concat(params.idx);
    (0,react.useEffect)(function() {
        setHeaderColor(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* default */.Z, {
                data: blogPostData.data,
                canonical: canonical
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AllBlogs, {
                allBlogs: all_blogs,
                allBlogCategories: all_blog_categories,
                params: params,
                blogPostData: blogPostData
            })
        ]
    });
};
var __N_SSG = true;
var queryParams = {
    fetchLinks: []
};
/* harmony default export */ var _idx_ = (BlogPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,774,888,179], function() { return __webpack_exec__(2199); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);